import { useTranslation } from "react-i18next";
import { X, Bot } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ChatKitPanel } from "@/components/chat/ChatKitPanel";

interface FleetAssistantSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  onShowHtml: (invocation: { params: { html: string } }) => void;
}

export function FleetAssistantSidebar({
  isOpen,
  onClose,
  onShowHtml,
}: FleetAssistantSidebarProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="h-full w-full bg-background border-l flex flex-col overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b bg-primary/5 shrink-0">
        <div className="flex items-center gap-2">
          <Bot className="h-5 w-5 text-primary" />
          <span className="font-semibold">{t("chat.title")}</span>
        </div>
        <Button variant="ghost" size="icon" onClick={onClose} className="h-8 w-8">
          <X className="h-4 w-4" />
        </Button>
      </div>

      <ChatKitPanel onShowHtml={onShowHtml} />
    </div>
  );
}
